import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Play, Square, Coffee, CheckCircle } from 'lucide-react';
import { formatTime, formatMinutes } from './helpers';

export const ActionButtons = ({ currentEntry, onAction, loading }) => (
  <div className="space-y-3 sm:space-y-4">
    {/* Current Status */}
    {currentEntry && (
      <Card className="bg-white/10 border-white/20 mb-4 sm:mb-6">
        <CardContent className="p-3 sm:p-4">
          <div className="flex justify-between items-center mb-2">
            <span className="text-gray-400 text-sm sm:text-base">Eingestempelt:</span>
            <span className="font-mono font-bold text-sm sm:text-base">{formatTime(currentEntry.clock_in)}</span>
          </div>
          {currentEntry.on_break && (
            <div className="flex justify-between items-center mb-2">
              <span className="text-gray-400 text-sm sm:text-base">In Pause seit:</span>
              <span className="font-mono text-amber-400 text-sm sm:text-base">
                {formatTime(currentEntry.breaks?.[currentEntry.breaks.length - 1]?.start_time)}
              </span>
            </div>
          )}
          <div className="flex justify-between items-center">
            <span className="text-gray-400 text-sm sm:text-base">Arbeitszeit:</span>
            <span className="font-mono text-sm sm:text-base">{formatMinutes(currentEntry.current_work_minutes)}</span>
          </div>
        </CardContent>
      </Card>
    )}

    {/* Action Buttons */}
    <div className="grid grid-cols-2 gap-3 sm:gap-4">
      {!currentEntry || !currentEntry.clock_in ? (
        <Button
          onClick={() => onAction('clock_in')}
          disabled={loading}
          data-testid="terminal-clock-in-btn"
          className="col-span-2 h-16 sm:h-20 md:h-24 text-lg sm:text-xl rounded-xl bg-green-600 hover:bg-green-700 active:scale-95"
        >
          <Play className="mr-2 sm:mr-3 h-6 w-6 sm:h-8 sm:w-8" />
          Kommen
        </Button>
      ) : currentEntry.clock_out ? (
        <div className="col-span-2 text-center p-4 sm:p-6 bg-gray-800 rounded-xl">
          <CheckCircle className="h-10 w-10 sm:h-12 sm:w-12 mx-auto mb-2 text-green-500" />
          <p className="text-base sm:text-lg">Bereits ausgestempelt</p>
          <p className="text-gray-400 text-sm sm:text-base">um {formatTime(currentEntry.clock_out)}</p>
        </div>
      ) : (
        <>
          {!currentEntry.on_break ? (
            <Button
              onClick={() => onAction('break_start')}
              disabled={loading}
              data-testid="terminal-break-start-btn"
              className="h-16 sm:h-20 md:h-24 text-base sm:text-lg rounded-xl bg-amber-600 hover:bg-amber-700 active:scale-95"
            >
              <Coffee className="mr-1 sm:mr-2 h-5 w-5 sm:h-6 sm:w-6" />
              Pause
            </Button>
          ) : (
            <Button
              onClick={() => onAction('break_end')}
              disabled={loading}
              data-testid="terminal-break-end-btn"
              className="h-16 sm:h-20 md:h-24 text-base sm:text-lg rounded-xl bg-blue-600 hover:bg-blue-700 active:scale-95"
            >
              <Play className="mr-1 sm:mr-2 h-5 w-5 sm:h-6 sm:w-6" />
              Weiter
            </Button>
          )}
          <Button
            onClick={() => onAction('clock_out')}
            disabled={loading}
            data-testid="terminal-clock-out-btn"
            className="h-16 sm:h-20 md:h-24 text-base sm:text-lg rounded-xl bg-red-600 hover:bg-red-700 active:scale-95"
          >
            <Square className="mr-1 sm:mr-2 h-5 w-5 sm:h-6 sm:w-6" />
            Gehen
          </Button>
        </>
      )}
    </div>
  </div>
);
